/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { IS_LOCAL_DEV } from '@zcode/env'
import { Dispatch } from 'redux'
import { AnyAction } from 'redux-actions'
import {
  MetricWithAttribution,
  onCLS,
  onFCP,
  onFID,
  onINP,
  onLCP,
  onTTFB,
} from 'web-vitals/attribution'

import { getEventLabel } from './getEventLabel'
import { isBrowserWindow } from './isBrowserWindow'

interface TrackWebVitalsArgs {
  bot?: boolean
  cityState?: string
  // traktor event from '@zcode/nr/es/shared/packages/traktor-middleware/actions'
  event: (payload: any) => AnyAction
  location?: any
  mobile?: boolean
  getPageType?: () => string
  user?: any
}

export const trackWebVitals =
  ({
    bot,
    cityState,
    event,
    location,
    mobile,
    getPageType,
    user,
  }: TrackWebVitalsArgs) =>
  (dispatch: Dispatch) => {
    const trackWebVitalMetric = (metric: MetricWithAttribution) => {
      const {
        attribution: {
          // @ts-expect-error
          interactionTargetElement: _,
          ...attribution
        },
        id,
        delta,
        entries,
        name,
        navigationType,
        rating,
        value,
      } = metric
      const props = {
        attribution,
        bot,
        cityState,
        // round after 5 decimals
        delta: Math.round(delta * 100000) / 100000,
        eventLabel: getEventLabel({ attribution, entries, id, name }),
        mobile,
        navigationType,
        pageType: getPageType?.() ?? '',
        rating,
        // round after 5 decimals
        value: Math.round(value * 100000) / 100000,
      }
      const eventArgs = {
        name,
        props,
        user,
        location,
      }
      if (IS_LOCAL_DEV) {
        console.log('Web Vitals Metric Event', eventArgs)
      } else {
        dispatch(event(eventArgs))
      }
    }

    if (isBrowserWindow()) {
      onCLS(trackWebVitalMetric)
      onINP(trackWebVitalMetric, { reportAllChanges: true })
      onFID(trackWebVitalMetric)
      onLCP(trackWebVitalMetric)
      onFCP(trackWebVitalMetric)
      onTTFB(trackWebVitalMetric)
    }
  }
